export default __webpack_public_path__ + "static/media/chevron-up.04ea1bbd.svg";